<template>
  <div class="error-container">
    <div class="error-content">
      <div class="error-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
      </div>
      <h1 class="error-code">401</h1>
      <h2 class="error-title">Session Expired</h2>
      <p class="error-description">
        Your session has expired for security reasons. Please log in again to continue using the application.
      </p>
      <div class="error-actions">
        <router-link to="/sign-in" custom v-slot="{ navigate }">
          <MaterialButton @click="navigate" color="success" variant="gradient" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
              <polyline points="10 17 15 12 10 7"></polyline>
              <line x1="15" y1="12" x2="3" y2="12"></line>
            </svg>
            Login Again
          </MaterialButton>
        </router-link>
        <router-link to="/" custom v-slot="{ navigate }">
          <MaterialButton @click="navigate" color="success" variant="outline" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            </svg>
            Return Home
          </MaterialButton>
        </router-link>
      </div>
      <!-- <div class="info-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <p>Sessions expire after a period of inactivity to protect your account.</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/common/MaterialButton.vue";


export default {
  name: 'SessionExpired',
  components: {
    MaterialButton
  }
}
</script>

<style scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.error-content {
  background: white;
  border-radius: 16px;
  padding: 60px 40px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.error-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  color: #ffc107;
}

.error-icon svg {
  width: 100%;
  height: 100%;
}

.error-code {
  font-size: 72px;
  font-weight: 800;
  color: #ffc107;
  margin: 0 0 16px;
  line-height: 1;
}

.error-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 16px;
}

.error-description {
  font-size: 16px;
  color: #718096;
  line-height: 1.6;
  margin: 0 0 32px;
}

.error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.link-unstyled {
  text-decoration: none;
}

.info-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 16px;
  text-align: left;
}

.info-box svg {
  flex-shrink: 0;
  color: #ffc107;
  margin-top: 2px;
}

.info-box p {
  margin: 0;
  font-size: 14px;
  color: #856404;
  line-height: 1.5;
}

@media (max-width: 480px) {
  .error-content {
    padding: 40px 24px;
  }
  
  .error-code {
    font-size: 56px;
  }
  
  .error-title {
    font-size: 24px;
  }
  
  .error-actions {
    flex-direction: column;
  }
}
</style>